export default "__VITE_ASSET__Xjk0ZKp9__"